var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticStyle:{"position":"relative"},style:({
    width: _vm.containerWidth,
    height: _vm.containerHeight,
  })},[_c('svg',{ref:"svg",attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xmls":"http://www.w3.org/2000/svg","version":"1.1","width":_vm.svgWidth,"height":_vm.svgHeight}})])}
var staticRenderFns = []

export { render, staticRenderFns }